/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './activateAccount.defs.js'
export * as $defs from './activateAccount.defs.js'
